import React from 'react';
import { compose, pure } from 'recompose';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DetailTextButton from '../atoms/DetailTextButton';
import EditTextButton from '../atoms/EditTextButton';

const styles = {};

const enhance = compose(pure);

const ShopTableBody = enhance(
  ({
    preShops,
    emptyRows,
    page,
    rowsPerPage,
    detailOpenAction,
    editOpenAction,
    order,
    orderBy
  }) => {
    let sortedResult;
    if (orderBy === 'streetAddress') {
      sortedResult = _.orderBy(
        preShops,
        ['prefectures', 'city', 'address', 'building'],
        [order, order, order, order]
      );
    } else {
      sortedResult = _.orderBy(preShops, orderBy, order);
    }
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(preShop => {
            const params = {
              id: preShop.preShopId
            };

            return (
              <TableRow key={preShop.preShopId}>
                <TableCell>
                  <EditTextButton
                    id={preShop.preShopId}
                    onClickAction={editOpenAction}
                  />
                </TableCell>
                <TableCell>{preShop.preShopName}</TableCell>
                <TableCell>
                  {preShop.prefectures}
                  {` `}
                  {preShop.city}
                  {` `}
                  {preShop.address}
                  {` `}
                  {preShop.building}
                </TableCell>
                <TableCell>{preShop.phone}</TableCell>
                <TableCell>{preShop.statusStr}</TableCell>
                <TableCell>{preShop.createdAt}</TableCell>
                <TableCell>
                  <DetailTextButton
                    params={params}
                    onClickAction={detailOpenAction}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ShopTableBody);
